export const formatPastTimeToOneIndicator = (dateParam) => {
  const date = typeof dateParam === "object" ? dateParam : new Date(dateParam);
  const today = new Date();
  const seconds = Math.round((today - date) / 1000);
  const minutes = Math.round(seconds / 60);
  const hours = Math.round(minutes / 60);
  const days = Math.round(hours / 24);

  if (seconds < 5) {
    return "now";
  } else if (seconds < 60) {
    return `${seconds} secs`;
  } else if (seconds < 90) {
    return "1 min";
  } else if (minutes < 60) {
    return `${minutes} min`;
  } else if (hours < 24) {
    return `${hours} ${hours === 1 ? "hour" : "hours"}`;
  } else if (days) {
    return `${days} ${days === 1 ? "day" : "days"}`;
  } else {
    return "";
  }
};

export function getSummary(text = "", length = 50) {
  return text.slice(0, length) + (text.length > length ? "..." : "");
}

function isCharacterAlphaNumeric(ch) {
  return ch.match(/^[a-z0-9]+$/i) !== null;
}

export function containsEmojis(str = "") {
  // Regular expression to match emoji
  const regexExp = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
  return regexExp.test(str);
}

export function containsOnlyEmojis(str = "") {
  let containAlphaNumeric = false;
  // Regular expression to match emoji
  if (containsEmojis(str)) {
    for (let i = 0; i < str.length; i++) {
      if (isCharacterAlphaNumeric(str[i])) {
        containAlphaNumeric = true;
        break;
      }
    }
  } else {
    return false;
  }
  return !containAlphaNumeric;
}

export function removeSpaces(str = "") {
  return str.split(" ").join("");
}
